<template>
    <input
        :value="value"
        @input="onInput($event)"
        @focus="onFocus($event)"
        @focusout="onFocusOut"
        @keydown.enter="onEnter($event)"
    >
</template>

<script>
    export default {
        props: {
            value: String,
        },
        methods: {
            onInput(e) {
                this.$emit('input', e.target.value);
            },
            onFocus(e) {
                this.$emit('focus', e.target.value);
            },
            onFocusOut(e) {
                this.$emit('focusout', e.target.value);
            },
            onEnter(e) {
                this.$emit('onEnter', e);
            },
        },
    }
</script>

<style scoped lang="scss">
    @import "resources/sass/_variables";

    input {
        display: block;
        font-weight: 400;
        background-color: #fff;
        background-clip: padding-box;
        transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        border: 1px solid $content-border-color;
        box-shadow: none;
        border-radius: 3px;
        color: #3b4a51;
        height: 38px;
        padding: 0 10px;
        width: 100%;
        font-size: 14px;

        &:hover {
            border-color: #14a2e2;
            box-shadow: none;
        }

        &:focus {
            color: #495057;
            background-color: #fff;
            outline: none;
        }

        &:disabled {
            cursor: not-allowed;
            background-color: $disabled_input_background_color;
        }

        &[type=number] {
            padding-right: 0 !important;
        }

        &[type=file] {
            padding: 5px 10px;
            height: 40px;
        }
    }
</style>
